import React, { Component } from "react";
import { Tab, Tabs } from "react-bootstrap";
import Loading from "../../../components/Loading";
import * as Business from "../../../utils/business";
import RetailTable from "./RetailTable";
import CorTable from "./CorTable";
import "./processing.style.scss";

class Processing extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleSelect = this.handleSelect.bind(this);
    this.state = {
      key: 1,
    };
  }

  handleSelect(key) {
    this.setState({ key });
  }

  render() {
    if (this.state.loading)
      return (
        <div style={{ height: Business.getHeightContent() }}>
          <Loading size="small" />
        </div>
      );

    return (
      true && (
        <div className="card">
          <div className="header">
            <h4 className="title">PROCESSING</h4>
          </div>
          <div className="tab-wrapper">
            <Tabs activeKey={this.state.key} onSelect={this.handleSelect}>
              <Tab eventKey={1} title="RETAIL CUSTOMERS">
                <RetailTable />
              </Tab>
              <Tab eventKey={2} title="CORPORATE CUSTOMERS">
                <CorTable />
              </Tab>
            </Tabs>
          </div>
        </div>
      )
    );
  }
}

export default Processing;



// WEBPACK FOOTER //
// src/pages/Pricing/Processing/Processing.js